import {makeStyles} from "@material-ui/core";
import {themeTypeToBool} from '../../utils/helpers';

export default makeStyles(theme => ({
    table: {
        marginTop: theme.spacing(1),
    },
    tableHeader: {
        background: themeTypeToBool(theme.palette.type) ? theme.palette.background.default : theme.palette.background.paper,
    },
    pointer: {
        cursor: "pointer",
    },
    cell: {
        textAlign: "center",
        padding: theme.spacing(1)
    },
    buttonLabel: {
        color: "#FAFAFA"
    },
    row: {
        display: "flex",
        justifyContent: "flex-end",
    },
    button: {
        margin: theme.spacing(1)
    }
}));